// extracted by mini-css-extract-plugin
export default {"ChartSupply":"ChartSupply_ChartSupply__M18Pr","ChartSupply__ChartContainer":"ChartSupply_ChartSupply__ChartContainer__Sx9L1"};